export default "__VITE_ASSET__BTiyZQ6V__"